import { useSelector } from 'react-redux'
import { botFlowSelector } from '../../../store/flow/selectors/botFlowSelector'
import { RootState } from '../../../reducers'

export const useGlobalStorages = () => {
  return useSelector((state: RootState) => botFlowSelector(state)?.globalStorages)
}
